import tw from 'tailwind-styled-components'
import {Context, UserType} from './types'
import {getGuestColor, getNameColor, getText} from './utils'

export const TwUserName = tw.div<{$context: Context}>`
  overflow-hidden
  text-ellipsis
  whitespace-nowrap
  ${p => getText(p.$context)}
`

export const TwName = tw.span<{$type: UserType; $context: Context}>`
  inline-block
  ${p => getNameColor(p.$type, p.$context)}
`

export const TwGuest = tw.span<{$context: Context}>`
  inline-block
  first:ml-0
  ml-8
  ${p => getGuestColor(p.$context)}
`
